<template>
    <div class="container mb-4 roadmap">
        <div
            v-for="(step, index) in info"
            :key="step.index"
            class="roadmap__step"
            :class="{ 'roadmap__step--active': index === activeStep }"
        >
            {{ step.index }}
            <section class="roadmap__content-container card">
                <h1 class="roadmap__heading">{{ step.title }}</h1>
                <div v-html="step.content"></div>
                <div class="button-container">
                    <template v-for="button in step.buttons">
                        <button
                            v-if="!button.link"
                            :key="button.index"
                            class="btn roadmap__button"
                            @click="
                                activeStep = button.nextStep;
                                wordlistActive = false;
                            "
                        >
                            {{ button.name }}
                        </button>
                        <a
                            v-else
                            :key="button.index"
                            class="btn roadmap__button"
                            :href="button.link.url"
                            :target="button.link.target"
                        >
                            {{ button.name }}
                        </a>
                    </template>
                </div>
            </section>
            <section
                v-if="step.wordList"
                class="roadmap__content-container roadmap__content-container--suffix card"
                :class="{
                    'roadmap__content-container--suffix-active': wordlistActive
                }"
            >
                <div class="accordion">
                    <h2>
                        <a
                            class="accordion__link"
                            href=""
                            :aria-expanded="wordlistActive ? 'true' : 'false'"
                            :class="{ 'accordion__link--open': wordlistActive }"
                            @click.prevent="toggleWordlist"
                            >Extra info</a
                        >
                    </h2>

                    <ul
                        class="wordlist"
                        :class="{ 'wordlist--open': wordlistActive }"
                        :aria-hidden="wordlistActive ? 'false' : 'true'"
                    >
                        <li
                            v-for="wordListItem in step.wordList"
                            :key="wordListItem.index"
                        >
                            <h3>{{ wordListItem.title }}</h3>
                            <p>
                                {{ wordListItem.explanation }}
                            </p>
                        </li>
                    </ul>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    data() {
        return {
            activeStep: 0,
            wordlistActive: false,
            info: null
        };
    },
    mounted() {
        this.getVacancyOverviewUrl();
    },
    methods: {
        getVacancyOverviewUrl() {
            axios
                .get('/api/v1/interactiveroadmap/getroadmap')
                .then(response => (this.info = response.data));
        },
        toggleWordlist() {
            this.wordlistActive = !this.wordlistActive;
        }
    }
};
</script>
